// Default floor plan layout - can be overridden by admin via DB

export const DEFAULT_ZONE_A_UPPER = [
  [177, 169, 161, 153, 145, 137, 129, 121],
  [176, 168, 160, 152, 144, 136, 128, 120],
  [175, 167, 159, 151, 143, 135, 127, 119],
  [174, 166, 158, 150, 142, 134, 126, 118],
];

export const DEFAULT_ZONE_A_LOWER = [
  [181,173, 165, 157, 149, 141, 133, 125, 117],
  [180,172, 164, 156, 148, 140, 132, 124, 116],
  [179,171, 163, 155, 147, 139, 131, 123, 115],
  [178,170, 162, 154, 146, 138, 130, 122, 114],
];

export const DEFAULT_ZONE_B = [
  [113, 109, 105, 101, 97, 93, 89, 85, 81, 80, 78, 76],
  [112, 108, 104, 100, 96, 92, 88, 84, null, null, null, null],
  [111, 107, 103, 99, 95, 91, 87, 83, 79, 77, 75, null],
  [110, 106, 102, 98, 94, 90, 86, 82, null, null, null, null],
];

export const DEFAULT_ZONE_C_UPPER = [
  [74, 67, 60, 53, 46, 39, 32, 25, 18, 11],
  [73, 66, 59, 52, 45, 38, 31, 24, 17, 10],
  [72, 65, 58, 51, 44, 37, 30, 23, 16, 9],
];

export const DEFAULT_ZONE_C_LOWER = [
  [71, 64, 57, 50, 43, 36, 29, 22, 15, 8],
  [70, 63, 56, 49, 42, 35, 28, 21, 14, 7],
  [69, 62, 55, 48, 41, 34, 27, 20, 13, 6],
  [68, 61, 54, 47, 40, 33, 26, 19, 12, 5],
];

export const CABINS = [
  { name: 'Ketan Solanki', seats: 4, label: 'Ketan Solanki' },
  { name: 'Chetna Vats', seats: 3, label: 'Chetna Vats' },
  { name: 'Vishwajit Rai', seats: 2, label: 'Vishwajit Rai' },
  { name: 'Sriram Gopalakrishnan', seats: 1, label: 'Sriram G.\nSSC Director' },
];

export const getDefaultLayout = () => ({
  zoneAUpper: DEFAULT_ZONE_A_UPPER,
  zoneALower: DEFAULT_ZONE_A_LOWER,
  zoneB: DEFAULT_ZONE_B,
  zoneCUpper: DEFAULT_ZONE_C_UPPER,
  zoneCLower: DEFAULT_ZONE_C_LOWER,
});

export const getAllSeatsFromLayout = (layout) => {
  const all = [];
  const blocks = [layout.zoneAUpper, layout.zoneALower, layout.zoneB, layout.zoneCUpper, layout.zoneCLower];
  blocks.forEach((zone) => {
    zone.forEach((row) => {
      row.forEach((seat) => {
        if (seat !== null && !all.includes(seat)) all.push(seat);
      });
    });
  });
  return all;
};

export const getAllZoneBlocks = (layout) => [
  layout.zoneAUpper, layout.zoneALower, layout.zoneB, layout.zoneCUpper, layout.zoneCLower,
];
